// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Value from "../Data.Value/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Value.eqValue);
var OrderDraftIsSymbol = {
    reflectSymbol: function () {
        return "OrderDraft";
    }
};
var OrderDraft = function (x) {
    return x;
};
var toFillFormTypeOrderDraft = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeOrderDraft_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqOrderDraft = {
    eq: function (x) {
        return function (y) {
            return eq(x)(y);
        };
    }
};
var genericOrderDraft = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showOrderDraft = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderDraft)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Value.showValue))(OrderDraftIsSymbol))
};
var unscrambleDecodeOrderDraft = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderDraft)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_Value.udecodeValue)))(Unscramble_Generic.defaultOptions)
};
var encodeOrderDraft = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericOrderDraft)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OrderDraftIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Value.encodeValue))))
};
var decodeOrderDraft = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericOrderDraft)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OrderDraftIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Value.decodeValue)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    OrderDraft,
    genericOrderDraft,
    eqOrderDraft,
    showOrderDraft,
    encodeOrderDraft,
    decodeOrderDraft,
    unscrambleDecodeOrderDraft,
    toFillFormTypeOrderDraft,
    newtypeOrderDraft_
};
